'use strict';

/**
* Checks if Capency is enabled for a specific type
* @param {string} type - the type for which Capency is being checked (e.g. 'email')
* @returns {boolean} - true if Capency is enabled, false otherwise
*/
function isCapencyEnabled(type) {
    let enabled = false;
    switch (type) {
        case 'email': {
            var $iscapEmailEnable = $('#isEnableCapEmail');
            if ($iscapEmailEnable.length > 0 && $iscapEmailEnable.val() === 'true' && $iscapEmailEnable.val() !== null) {
                enabled = true;
            }
            break;
        }
        case 'phone': {
            let $iscapPhoneEnable = $('#isEnableCapPhone');
            if ($iscapPhoneEnable.length > 0 && $iscapPhoneEnable.val() === 'true' && $iscapPhoneEnable.val() !== null) {
                enabled = true;
            }
            break;
        }
        case 'address': {
            let $iscapAddressEnable = $('#isEnableCapAddress');
            if ($iscapAddressEnable.length > 0 && $iscapAddressEnable.val() === 'true' && $iscapAddressEnable.val() !== null) {
                enabled = true;
            }
            break;
        }
        default:
            break;
    }
    return enabled;
}

/**
* Sets the validation state of a field and updates its visual representation
* @param {jQuery} $selector - the jQuery selector for the field element
* @param {boolean} state - the validation state (true for valid, false for invalid)
* @returns {void}
*/
function setFieldValid($selector, state) {
    if (state !== true) {
        $selector.addClass('is-invalid');
        $selector.removeClass('is-valid');
        $selector.data('validated', false);
    } else {
        $selector.next('.invalid-feedback').hide();
        $selector.removeClass('is-invalid');
        $selector.addClass('is-valid');
        $selector.data('validated', true);
    }
}

/**
* Removes field validation results
* @param {jQuery} $selector - the jQuery selector for the field
*/
function removeFieldValidationResults($selector) {
    $selector.next('.invalid-feedback').hide();
    $selector.removeClass('is-invalid');
    $selector.removeClass('is-valid');
    $selector.data('validated', false);
}

/**
* Sets the required error message for the given selector
* @param {jQuery} $selector - The jQuery selector for the input field
* @returns {void}
*/
function setRequiredError($selector) {
    if ($selector && $selector.val().length === 0) {
        setFieldValid($selector, false);
        let errorMessage = $selector.data('messageRequired');
        if (errorMessage) {
            $selector.next('.invalid-feedback').text(errorMessage).show();
        }
    }
}

/**
* Validates the phone number input field.
* Checks if the phone number has been validated and if it is not empty.
* If the phone number is not validated or is empty, sets an error message and focuses the input field.
*
* @returns {boolean} - Returns true if the phone number is validated, otherwise false.
*/
function validatePhone() {
    let $phoneSelector = $('.registration [name="dwfrm_profile_customer_phone"]');
    if ($phoneSelector.data('validated') !== true) {
        if ($phoneSelector.val().length === 0) {
            setRequiredError($phoneSelector);
        }
        $phoneSelector.focus();
        return false;
    }
    return true;
}

function fillZipCodeWithAllCapData($zipSelector, data) {
    if ($zipSelector.length > 0) {
        $zipSelector.attr('data-address', JSON.stringify(data));
    }
}

function resetModifiedFlagOnAddressFields() {
    const fields = [
        $('input[name$="_address1"]'),
        $('input[name$="_address2"]'),
        $('input[name$="_city"]'),
        $('input[name$="_postal"]'),
    ];

    resetModifiedFlagOnFields(fields);
}

function resetModifiedFlagOnEmailFields() {
    const fields = [
        $('input[name$="_email"]'),
    ];

    resetModifiedFlagOnFields(fields);
}

function resetModifiedFlagOnFields(fields) {
    fields.forEach(function (field) {
        field.data('isModified', false)
    });
}

function isAddressFormModified() {
    const fields = [
        $('input[name$="_address1"]'),
        $('input[name$="_address2"]'),
        $('input[name$="_city"]'),
        $('input[name$="_postal"]'),
    ];
    return checkFieldsModified(fields);
}

function isEmailFormModified() {
    const fields = [
        $('input[name$="_email"]'),
    ];
    return checkFieldsModified(fields);
}

function checkFieldsModified(fields) {
    return fields.some(function (field) {
        return field.data('isModified')
    });
}

module.exports = {
    isCapencyEnabled: isCapencyEnabled,
    setFieldValid: setFieldValid,
    removeFieldValidationResults: removeFieldValidationResults,
    setRequiredError: setRequiredError,
    validatePhone: validatePhone,
    fillZipCodeWithAllCapData: fillZipCodeWithAllCapData,
    isAddressFormModified: isAddressFormModified,
    isEmailFormModified: isEmailFormModified,
    resetModifiedFlagOnAddressFields: resetModifiedFlagOnAddressFields,
    resetModifiedFlagOnEmailFields: resetModifiedFlagOnEmailFields
};
